import { useEffect, useState } from 'react';
import { keyBy as _keyBy } from 'lodash';

import { toggleAttrOptions } from '../rule/rule-utils';
import type { Condition, Attribute } from '../rule/rule-utils';

export const useAttrOptionsState = (conditions: Condition[], attributes: Attribute[]) => {
	const attrState = useState<Attribute[]>(() => {
		const conditionByPath = _keyBy(conditions, 'path');
		return toggleAttrOptions(attr => conditionByPath[attr.path], { disabled: true }, attributes);
	});
	const [, setAttrOptions] = attrState;

	useEffect(() => {
		const conditionByPath = _keyBy(conditions, 'path');
		setAttrOptions(toggleAttrOptions(attr => conditionByPath[attr.path], { disabled: true }, attributes));
	}, [conditions]);

	return attrState;
};
